import { z } from 'zod'
import { oc } from '@orpc/contract'

/**
 * The email duplicate check for the Provider Portal's "New patient" (PD-1885). The caller's own
 * single chart with the email is the one to open instead of creating one. A chart only in another
 * practice, or several charts, is `ambiguous`: nothing is chosen or attached. `creating` (PD-1930):
 * another request for the email was cleared to create a chart moments ago, so this one must not.
 * POST, so the email never lands in an access log.
 */
export const patientFindDuplicate = oc
  .route({ method: 'POST', path: '/v2/patient/duplicate-check' })
  .input(
    z.object({
      email: z.string().trim().min(3),
      organizationId: z.string().min(1),
    }),
  )
  .output(
    z.object({
      patientId: z.string().nullable(),
      ambiguous: z.boolean(),
      creating: z.boolean().optional(),
    }),
  )
